<template>
  <v-card class="jumbotron">
    <v-container>
      <h2>Error 404 - Not Found</h2>
      <p>The requested page does not exist.</p>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'notFound',
};
</script>
